// Разделы, закрытые пометкой «Скоро»: пункт меню не нажимается (Navigation.tsx),
// раздел справки скрыт (HelpDrawer.tsx). Раздел открыли — поставить false.
export const COMING_SOON = {
  learning: true,
  review360: false,
} as const;

/** Скрытый флаг: открывает закрытые разделы для e2e и разработки. На странице бета-функций его нет. */
export const PREVIEW_SOON_FLAG = 'previewSoon';
